import { IconEye } from '@tabler/icons-react';
import { APP_ROUTES } from '@zorro/common-utils';
import { Button } from '@zorro/design-system/v2/Button';
import { Drawer } from '@zorro/design-system/v2/Drawer';
import { Link } from '@zorro/design-system/v2/Link';
import { DataTable, Icon } from '@zorro/web/design-system';
import { DataTableColumn } from 'mantine-datatable';
import { useState } from 'react';

import { useBulkApplication } from './BulkApplicationContext';

type EmployeeRow = {
  id: string;
  shortId: string;
  employeeId: string;
  employeeName: string;
  employerId: string;
  employerName: string;
  onboardingPeriodId: string;
  numberOfInsured: number;
};

export const BulkApplicationViewEmployeesButton = () => {
  const { enrollmentSummary } = useBulkApplication();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (!enrollmentSummary) {
    return null;
  }

  const records: EmployeeRow[] = enrollmentSummary.onboardingPeriods.map(
    ({
      employeeId,
      employeeName,
      employerId,
      employerName,
      onboardingPeriodId,
      numberOfInsured,
    }) => ({
      id: employeeId,
      shortId: employeeId.slice(0, 8),
      employeeId,
      employeeName,
      employerId,
      employerName,
      onboardingPeriodId,
      numberOfInsured,
    })
  );

  const columns: DataTableColumn<EmployeeRow>[] = [
    {
      title: 'ID',
      accessor: 'shortId',
    },
    {
      title: 'Full name',
      accessor: 'employeeName',
      render: ({
        employeeId,
        employeeName,
        employerId,
        onboardingPeriodId,
      }) => (
        <Link
          href={APP_ROUTES.OPS_EMPLOYEE_PLANS_TAB({
            employerId,
            employeeId,
            onboardingPeriodId,
          })}
          target="_blank"
        >
          {employeeName}
        </Link>
      ),
    },
    {
      title: 'Employer (legal name)',
      accessor: 'employerName',
    },
    {
      title: 'Insured',
      accessor: 'numberOfInsured',
    },
  ];

  return (
    <>
      <Button
        leftSection={<Icon icon={IconEye} />}
        onClick={() => setIsOpen(true)}
        variant="secondary"
      >
        View employee list
      </Button>
      <Drawer
        title="Review employee list"
        onClose={() => setIsOpen(false)}
        opened={isOpen}
        position="right"
      >
        <DataTable columns={columns} records={records} />
      </Drawer>
    </>
  );
};
